(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 899px)');
  if (!mobileQuery.matches) return;

  const root = document.documentElement;
  root.classList.add('oni-mobile-layout');

  function setViewportHeight() {
    root.style.setProperty('--oni-mobile-vh', `${window.innerHeight * 0.01}px`);
  }
  setViewportHeight();
  window.addEventListener('resize', setViewportHeight, { passive: true });
  window.addEventListener('orientationchange', setViewportHeight, { passive: true });

  function closeMobileMenu() {
    const hamburger = document.querySelector('.nav-hamburger');
    const menu = document.querySelector('.nav-mobile');
    if (!hamburger || !menu) return;

    hamburger.classList.remove('open');
    menu.classList.remove('open');
    menu.style.opacity = '0';
    menu.style.transform = 'translateY(-8px)';
    root.classList.remove('mobile-menu-open');
    hamburger.setAttribute('aria-expanded', 'false');

    window.setTimeout(() => {
      if (!hamburger.classList.contains('open')) menu.style.display = 'none';
    }, 220);
  }

  function initMobileMenuSafety() {
    const hamburger = document.querySelector('.nav-hamburger');
    const menu = document.querySelector('.nav-mobile');
    if (!hamburger || !menu) return;

    hamburger.setAttribute('aria-expanded', hamburger.classList.contains('open') ? 'true' : 'false');

    const sync = () => {
      const open = hamburger.classList.contains('open') || menu.classList.contains('open');
      root.classList.toggle('mobile-menu-open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const observer = new MutationObserver(sync);
    observer.observe(hamburger, { attributes: true, attributeFilter: ['class'] });
    observer.observe(menu, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('pointerdown', (event) => {
      if (!hamburger.classList.contains('open')) return;
      if (menu.contains(event.target) || hamburger.contains(event.target)) return;
      closeMobileMenu();
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMobileMenu();
    });

    menu.querySelectorAll('a, button').forEach((control) => {
      control.addEventListener('click', () => {
        if (!control.matches('[data-oni-cart-trigger]')) closeMobileMenu();
      });
    });

    window.addEventListener('orientationchange', closeMobileMenu, { passive: true });
  }

  function prepareHomeReviewsLoop() {
    const track = document.getElementById('wbrc-track');
    if (!track || track.dataset.oniMobileLoopReady === 'true') return;

    // The section's inline script normally duplicates the cards for the desktop loop.
    // Keep that duplicate set on mobile as well, and only create it when a delayed
    // script or app prevented the inline duplication from running.
    const cards = [...track.children];
    if (cards.length && cards.length < 10) {
      cards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }
    track.dataset.oniMobileLoopReady = 'true';
  }

  function syncPlanCardHeight(shell) {
    if (!(shell instanceof HTMLElement)) return;
    const inner = shell.querySelector('.wbp-flip-inner');
    const front = shell.querySelector('.wbp-card-front');
    const back = shell.querySelector('.wbp-card-back');
    if (!inner || !front || !back) return;

    const flipped = shell.classList.contains('is-flipped');
    const active = flipped ? back : front;

    requestAnimationFrame(() => {
      const natural = Math.ceil(active.scrollHeight || active.getBoundingClientRect().height || 0);
      const minimum = flipped ? 680 : 610;
      const height = Math.max(minimum, natural);
      shell.style.setProperty('min-height', `${height}px`, 'important');
      shell.style.setProperty('height', `${height}px`, 'important');
      inner.style.setProperty('min-height', `${height}px`, 'important');
      inner.style.setProperty('height', `${height}px`, 'important');
    });
  }

  function initPlanHeightSync() {
    const shells = [...document.querySelectorAll('.wbp-plan-shell')];
    if (!shells.length) return;

    const syncAll = () => shells.forEach(syncPlanCardHeight);

    shells.forEach((shell) => {
      syncPlanCardHeight(shell);

      // Only observe the flip-state class. The old subtree observers reacted to every
      // add-on render and caused needless layout work while the user scrolled.
      const classObserver = new MutationObserver(() => {
        syncPlanCardHeight(shell);
        window.setTimeout(() => syncPlanCardHeight(shell), 180);
      });
      classObserver.observe(shell, { attributes: true, attributeFilter: ['class'] });
    });

    document.addEventListener('click', (event) => {
      const shell = event.target.closest?.('.wbp-plan-shell');
      if (!shell) return;
      window.setTimeout(() => syncPlanCardHeight(shell), 40);
      window.setTimeout(() => syncPlanCardHeight(shell), 260);
      window.setTimeout(() => syncPlanCardHeight(shell), 650);
    }, { passive: true });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncAll, 140);
    }, { passive: true });

    if (document.fonts?.ready) {
      document.fonts.ready.then(syncAll).catch(() => {});
    }
    window.setTimeout(syncAll, 450);
  }

  function initScrollPerformanceMode() {
    let timer = null;
    window.addEventListener('scroll', () => {
      root.classList.add('oni-mobile-scrolling');
      clearTimeout(timer);
      timer = window.setTimeout(() => root.classList.remove('oni-mobile-scrolling'), 130);
    }, { passive: true });
  }

  function init() {
    initMobileMenuSafety();
    prepareHomeReviewsLoop();
    initPlanHeightSync();
    initScrollPerformanceMode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
